import { Grid } from '@mui/material';
import InputForm from './input-form';
import React from 'react';
import './meter-reading.scss';

/**
 * Composant Relevé de compteur
 * @constructor
 */
export default function MeterReading(props: { columNumber: number }) {
    // Changement de focus après saisie d'un caractère
    const handleChangeFocus = (event: any) => {
        if (event.target.value.length > 1) {
            event.target.value = event.nativeEvent.data;
        }
        switch (event.target.id) {
            //Si on est sur la case 1 on va sur la 2
            case 'numberOne':
                document.getElementById('numberTwo')?.focus();
                break;
            //Si on est sur la case 2 on va sur la 3
            case 'numberTwo':
                document.getElementById('numberThree')?.focus();
                break;
            //Si on est sur la case 3 on va sur la 4
            case 'numberThree':
                document.getElementById('numberFour')?.focus();
                break;
            //Si on est sur la case 4 on va sur la 5
            case 'numberFour':
                document.getElementById('numberFive')?.focus();
                break;
        }
    };

    return (
        //Mise en place dans un grid
        <Grid className="meter-reading-component" container spacing={1} columns={props.columNumber}>
            <Grid item xs={3} sm={1}>
                {/*Champ un*/}
                <InputForm
                    type="number"
                    id="numberOne"
                    name="numberOne"
                    required
                    handleChange={handleChangeFocus}
                    InputProps={{ inputProps: { min: 0, max: 9 } }}
                ></InputForm>
            </Grid>
            <Grid item xs={3} sm={1}>
                {/*Champ deux*/}
                <InputForm
                    type="number"
                    id="numberTwo"
                    name="numberTwo"
                    required
                    handleChange={handleChangeFocus}
                    InputProps={{ inputProps: { min: 0, max: 9 } }}
                ></InputForm>
            </Grid>
            <Grid item xs={3} sm={1}>
                {/*Champ trois*/}
                <InputForm
                    type="number"
                    id="numberThree"
                    name="numberThree"
                    required
                    handleChange={handleChangeFocus}
                    InputProps={{ inputProps: { min: 0, max: 9 } }}
                ></InputForm>
            </Grid>
            <Grid item xs={3} sm={1}>
                {/*Champ quatre*/}
                <InputForm
                    type="number"
                    id="numberFour"
                    name="numberFour"
                    required
                    handleChange={handleChangeFocus}
                    InputProps={{ inputProps: { min: 0, max: 9 } }}
                ></InputForm>
            </Grid>
            <Grid item xs={3} sm={1}>
                {/*Champ cinq*/}
                <InputForm
                    type="number"
                    id="numberFive"
                    name="numberFive"
                    required
                    handleChange={handleChangeFocus}
                    InputProps={{ inputProps: { min: 0, max: 9 } }}
                ></InputForm>
            </Grid>
            {/*Champ six*/}
            <Grid item xs={3} sm={1}>
                <InputForm id="numberSix" name="numberSix" disabled={true}></InputForm>
            </Grid>
            {/*Champ sept*/}
            <Grid item xs={3} sm={1}>
                <InputForm id="numberSeven" name="numberSeven" disabled={true}></InputForm>
            </Grid>
            {/*Champ huit*/}
            <Grid item xs={3} sm={1}>
                <InputForm id="numberHeight" name="numberHeight" disabled={true}></InputForm>
            </Grid>
        </Grid>
    );
}
